import ManualList from './List';
import ManualForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/manuais-usuario',
    name: 'Cadastro Manuais Usuário',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'manuais-usuario',
            name: 'list-manual',
            component: ManualList,
            meta: {
                requiresAuth: true,
                label: 'Listar Manuais Usuário'
            }
        },
        {
            path: 'manuais-usuario/novo',
            name: 'new-manual',
            component: ManualForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Manual Usuário'
            }
        },
        {
            path: 'manuais-usuario/:id',
            name: 'edit-manual',
            component: ManualForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Manual Usuário'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/manual/router.js